import React, {useEffect, useState} from 'react';
import BenefitSectionBox from "@product/features/benefitsection/index.ts";
import {BenefitSectionItemAttributes} from "@product/features/benefitsection/benefit-section-item-attribute.ts";
import {Typography} from "@bonprix/design-system";
import Breakpoint from "@core/scripts/helper/breakpoint.js";
import MessageBroker from "@bonprix/pattern-library/components/message-broker.js";
import Messages from "@core/scripts/components/messages.js";

export default function BenefitSection({product}) {

    const getHideIfMissingAttributes = (product) => {
        const hideIfMissing = [];

        // for better understanding, there are two chained if statements
        if (!product.currentItemOption) {
            if (product.currentItem?.itemOptions.some(option => !option.parcelShopDelivery)) {
                hideIfMissing.push(BenefitSectionItemAttributes.PARCEL_SHOP_DELIVERY);
            }
        } else {
            if (!product.currentItemOption.parcelShopDelivery) {
                hideIfMissing.push(BenefitSectionItemAttributes.PARCEL_SHOP_DELIVERY);
            }
        }
        return hideIfMissing;
    };

    const hideIfMissing = getHideIfMissingAttributes(product);

    return (
        <div className='flex flex-col flex-1 mt-4 px-2 l:px-0'>
            <BenefitSectionBox items={product?.benefitSection?.items || []} hideIfMissing={hideIfMissing}/>
        </div>
    );
}
